import is, { isNot } from 'typescript-styled-is'
import styled from '../../../theme'
import { Input as BaseInput } from '../elements'
import { IInputProps } from '../elements/Input'
import { DecreaseButton, IncreaseButton } from './Button'

const Input = styled(BaseInput)<IInputProps>`
  min-width: 30px;
  width: calc(100% - ${({ size }) => (size ? 62 * size : 62)}px);

  text-align: center;
  background: none;
  ${isNot('withoutPicker')`
    border: none;
  `};
  
  padding: 0;

  ${is('withoutPicker')`
    text-align: left;
    box-shadow: unset;
    width: 100%;
    padding-left: ${({ size }) => (size ? 10 * size : 10)}px;
  `}
  
  ${is('disabled')`
    background: #F5F5F5;
  `}

  ${DecreaseButton} + &,
  & + ${IncreaseButton} {
    border: none;
  }
  

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance:textfield;
`

export default Input
